var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { class: ["header-component", { "is-mobile": _setup.isMobileBreakpoint }] },
    [
      _c(
        "header",
        { staticClass: "header-login" },
        [_c(_setup.LefebvreLogoComponent)],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }